import cn from 'classnames'
import styles from './styles.module.css'


const ConferenceSchoolCheckbox = ({
    count,
    onChange,
    className,
    color,
    value = false,
    name,
    id
}) => {
    const clickHandler = () => {
        onChange && onChange(id)
    }
    const classNames = cn(styles.checkbox, className, {
        [styles['checkbox_active']]: value
    })
    return <div className={styles['checkbox-container']}>
        <div>
            <button
                className={classNames}
                onClick={clickHandler}
                type='button'
                color={color}
            >
                <span>{name}</span>
            </button>
        </div>
        
        <div className={styles.tags__count}>{count}</div>
    </div>
}

export default ConferenceSchoolCheckbox;